
export default {
	appname: 'SWAPP',
	organisation: 'Ministry of Furniture',
	primary: "#6F2D86",
	secondary: "#371549",
	accent: "#C4CF5A",
	error: "#b71c1c",
}
